import '../../scss/modules/_slider.scss'

import Vue from 'vue'
import vueCustomElement from 'vue-custom-element'
//import 'document-register-element/build/document-register-element'; // IE polyfill
Vue.use(vueCustomElement)

import VSlider from './VSlider/VSlider.vue'
Vue.customElement('v-slider', VSlider)

import VSliderCourses from './VSliderCourses/VSliderCourses.vue'
Vue.customElement('v-slider-courses', VSliderCourses)
